module.exports = __webpack_public_path__ + "static/media/repair-info.be19d78a.png";